// @ts-check
/** Pure helpers for filling a product's model fields from a fashion model profile. */

/** Trim an API decimal ("34.0" or 34) to display text ("34"); blank stays blank. */
export const numText = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  return Number.isFinite(n) ? String(n) : '';
};

/**
 * "Height: 5'9", Bust: 32, Waist: 24, Hips: 35" - the exact format the storefront shows and the
 * product form parses by comma position, so all four slots are always present.
 * @param {{height: string, bust_in: string | number, waist_in: string | number, hips_in: string | number}} model
 */
export const formatModelMeasurements = (model) =>
  `Height: ${model.height}, Bust: ${numText(model.bust_in)}, Waist: ${numText(model.waist_in)}, Hips: ${numText(model.hips_in)}`;

/**
 * Form fields to merge into the product form when a model is picked, or cleared with null.
 * Clearing only unlinks: the text already on the product stays, since it is a snapshot the admin
 * may have tuned by hand. The wearing size is only defaulted while it is still blank.
 * @param {any} model
 * @param {string} currentWearingSize
 */
export const fashionModelFormFields = (model, currentWearingSize) => {
  if (!model) return { fashion_model_id: '' };
  return {
    fashion_model_id: model.id,
    model_measurements: formatModelMeasurements(model),
    model_wearing_size: currentWearingSize || model.usual_size || '',
  };
};
